import { render, staticRenderFns } from "./rfq-supplier-form.vue?vue&type=template&id=5ef71473"
import script from "./rfq-supplier-form.vue?vue&type=script&lang=js"
export * from "./rfq-supplier-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports